import { exists } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        config,
        get alertBar() {
            return document.querySelector('.c-cu-alert-bar:not(.js-is-hidden)');
        },
        topBar: node.querySelector(`.c-nav__top`),
        bottomBar: node.querySelector(`.c-nav__bottom`),
    };

    let module = {
        makeLayout() {
            document.documentElement.style.setProperty(
                '--nav-height',
                `${state.node.getBoundingClientRect().height}px`
            );
            if (exists(state.alertBar)){
                document.documentElement.style.setProperty('--alert-bar-spacer-height', `${state.alertBar.getBoundingClientRect().height}px`);
            } else {
                document.documentElement.style.setProperty('--alert-bar-spacer-height', '0px');
            }
            if (!exists(state.topBar)) return;
            document.documentElement.style.setProperty('--top-bar-height', `${state.topBar.getBoundingClientRect().height}px`);
            if (!exists(state.bottomBar)) return;
            document.documentElement.style.setProperty('--bottom-bar-height', `${state.bottomBar.getBoundingClientRect().height}px`);
        },
        forceOffset() {
            console.log('force event received');
        },
        setEventBindings() {
            window.addEventListener('load', this.makeLayout.bind(this));
            window.addEventListener('resize', this.makeLayout.bind(this));
            //window.addEventListener('forceNavOffset', this.makeLayout.bind(this));
        },
        init() {
            if (!exists(state.node)) return;
            this.makeLayout();
            this.setEventBindings();
        },
    };

    return module.init();
};

export default {
    init({ selector, config = {} }) {
        let selected = document.querySelectorAll(selector);
        if (!selected.length) return;

        return [...selected].map((node, index) => {
            return mixin({ node, config });
        });
    },
};
